function helperGetDateMonth (date) {
  return date.getMonth()
}

module.exports = helperGetDateMonth



//////////////////
// WEBPACK FOOTER
// ./node_modules/xe-utils/helperGetDateMonth.js
// module id = dA88
// module chunks = 37